/** The rebalancing import context extracted from `fineco:fineco_imported_portfolio`. */
export interface ImportContext {
  /** The client's financial plan (1-8) from SSO, or null when absent. */
  financialPlan: number | null;
  /** The client's risk profile (Italian label) from SSO, or null when absent. */
  riskProfile: string | null;
}

/**
 * Extract the import context from the `fineco:fineco_imported_portfolio` metadata
 * object (the JWT payload). Returns nulls for any field that is absent.
 */
export function extractImportContext(imported: unknown): ImportContext {
  const customerData =
    imported && typeof imported === 'object'
      ? (imported as { customer_data?: Record<string, unknown> }).customer_data
      : undefined;

  const rawPlan = customerData?.financialPlan;
  let financialPlan: number | null = null;
  if (typeof rawPlan === 'number') {
    financialPlan = rawPlan;
  } else if (typeof rawPlan === 'string' && rawPlan.trim() !== '') {
    const parsed = parseInt(rawPlan, 10);
    financialPlan = Number.isNaN(parsed) ? null : parsed;
  }

  const rawProfile = customerData?.risk_profile;
  const riskProfile = typeof rawProfile === 'string' ? rawProfile : null;

  return { financialPlan, riskProfile };
}
